import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct/products/price'

export default ($axios) => ({
  getPricePerSku (variantSku, categoryId) {
    return $axios.get(`${resource}/option/${variantSku}/${categoryId}`)
  }
})
